import React, { useEffect, useRef, useState } from "react";
import cx from "classnames";
import styles from "./index.module.scss";

export type SpikexSelectOption = { value: number | string; label: string };

interface SpikexSelectFieldProps {
  className?: string;
  placeholder: string;
  value?: number | string;
  options: SpikexSelectOption[];
  onChange?: (value: number | string) => void;
}

const SpikexSelectField: React.FC<SpikexSelectFieldProps> = ({ className, placeholder, value, options, onChange }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const selected = options.find((item) => item.value === value);

  useEffect(() => {
    if (!open) return;
    const handlePointerDown = (event: MouseEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handlePointerDown);
    return () => document.removeEventListener("mousedown", handlePointerDown);
  }, [open]);

  return (
    <div ref={rootRef} className={cx(styles.root, className)}>
      <button type="button" className={styles.trigger} onClick={() => setOpen((prev) => !prev)}>
        <span className={selected ? styles.value : styles.placeholder}>{selected?.label || placeholder}</span>
        <span className={cx(styles.chevron, open && styles.chevronOpen)} aria-hidden />
      </button>
      {open ? (
        <div className={styles.panel}>
          {options.map((item) => (
            <button
              key={item.value}
              type="button"
              className={cx(styles.option, item.value === value && styles.optionActive)}
              onClick={() => {
                onChange?.(item.value);
                setOpen(false);
              }}
            >
              {item.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SpikexSelectField;
